import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { HomeService } from './home.service';
import { FileUploader } from 'ng2-file-upload';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as XLSX from 'xlsx';
import { UserService } from '../user.service';
declare var $:any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

 
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  paginatetest:boolean;
  uploadForm1: FormGroup;

  isOk: boolean;
  isOk1: boolean;

  displayedColumns = ['id', 'civilite','nom','adresse','codepostal','ville','tel1', 'tel2','mail','commentaire','edit','delete'];
   tabCodePostal : string[] = [];

  listFiche:any;
  listResult:any;
  listResult1:any;
  email
  statut
  tel
  codepostal
  t1:any;
pas:number;
  
  public uploader1:FileUploader = new FileUploader({
    isHTML5: true
  });
  reader: FileReader = new FileReader();

  constructor(private router:Router,private _service:HomeService,private _formBuilder:FormBuilder,public tokenStorageService: UserService) {
    for(let i = 10;i<96;i++){
      this.codeP.push(i.toString())

    }
    console.log(this.codeP)
   }

  liste:boolean;


listeHome(){
  this.liste = true;
  this._service.getFicheBdd(this.getPas).subscribe(e=>{
    this.listFiche= e;
    this.listResult = this.listFiche;
    this.listResult = new MatTableDataSource(this.listResult);
  
 
    this.listResult.paginator = this.paginator;
    this.listResult.sort = this.sort;

    console.log(this.listFiche)
  })

}
filtreTab
resultFiltre
okDownload = false;
download

filtre(){
  this.liste = true;
  this.paginatetest = true;
  this.filtreTab ={
    mail:this.email,
    code_postal:this.codepostal,
    tel:this.tel,
    statu_habitation:this.statut,
    pas:this.getPas1
  }
 this._service.getFicheFiltrer(this.filtreTab).subscribe(
   data=>{
    this.okDownload = false;
     this.resultFiltre = data;
     this.listResult = this.resultFiltre;
    // this.download = this.resultFiltre.fichier;
     console.log(data)
     if(this.listResult.length != 0){
      this.okDownload = true;
     }
     this.listResult = new MatTableDataSource(this.listResult);
  
 
    this.listResult.paginator = this.paginator;
    this.listResult.sort = this.sort;
    
     
   },error=>{
     console.log("errrrrreuuuuuurrr")
   }
 )
}

downloadFilter(){
  window.location.href = 'http://www.testback.kompar-energie.com/'+this.download;
}
userArray
getPas
  ngOnInit() {
    this.nbrpa = 0;
    this.nbrpa1 = 0;

    this.paginatetest = false;
    this.getPas1 = 0;
    this.getPas = 0;
    this.pas = 0;
    this.pasHide = "";
    this.telechargerProvisoir = '';
    this.liste = true;
  
 this.uploadForm1 = this._formBuilder.group({
      document: [null, null]
    });
    this.reader.onload = (ev: any) => {
      console.log(ev.target.result.json);
      
      
  
  };
  this.uploader1.onAfterAddingFile = (fileItem: any) => {
      this.reader.readAsText(fileItem._file);
      console.log(fileItem)
  };

  
    this._service.getFicheBdd(this.getPas).subscribe(e=>{
      this.listFiche= e;
      this.listResult = this.listFiche;
      this.listResult = new MatTableDataSource(this.listResult);  
      this.listResult.paginator = this.paginator;
      this.listResult.sort = this.sort;

      console.log(this.listFiche)
    })
  }

   
   applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.listResult.filter = filterValue;

  }

data1
data2

uploadData 
pasHide
  uploadSubmit1(){

    for (let i = 0; i < this.uploader1.queue.length; i++) {
      let fileItem = this.uploader1.queue[i]._file;
      console.log(fileItem)
      if(fileItem.size > 90000000){
        alert("Taille du fichier doit être inférieure à  90 MB.");
        return;
      }
    }
    for (let j = 0; j < this.uploader1.queue.length; j++) {
      let data = new FormData();
      let fileItem = this.uploader1.queue[j]._file;
      data.append('file', fileItem);
      data.append('fileSeq', 'seq'+j);
    //  data.append('id',this.id_file);
    
    // this.uploadFile(data).subscribe(data => alert(data.message));
    this._service.uploadBDD(data).subscribe(data=>{
       console.log(data)
     this.uploadData = data;
     this.data2= data;
     if(this.data2.status =="fichier invalide !"){
      this.isOk1 =false;
      setTimeout(()=>{                           //<<<---using ()=> syntax
        this.isOk1 = null;
   }, 5000);
     }else{
      this.isOk1 =true;
      this.pasHide = "oui"
      setTimeout(()=>{                           //<<<---using ()=> syntax
        this.isOk1 = null;
   }, 5000);
     }
 
   },error=>{
    this.isOk1 =false;
    setTimeout(()=>{                           //<<<---using ()=> syntax
      this.isOk1 = null;
 }, 5000);
     })

    }
   
    this.uploader1.clearQueue();
    this.data = [];
    this.dataExel = null;

  }
disable = false;
data11
message:string;

addPas(){
  this.disable = true;
  this.message = "Veuillez patienter ... le fichier se charge"
  var data = {
    url : this.uploadData.status.url,
    pas : this.pas,
    extention : this.uploadData.status.exention
}
this.pas ++;
  
this._service.uploadBDD1(data).subscribe(data=>{
  console.log(data)
  this.data11 = data;
  console.log(this.data11.more)
  this.message = "";
  this.disable = false;;

  if(this.data11.more == false){
    this.pasHide = "";
  }

})
}
nbrpa1:number
  isOk2:boolean;
  nbrpa:number;
  urlExport
  emptyExport
  dataExport
  testExport
  disabledExport = false;
  disabledExport1 = false;

  exporter(){
   this.testExport = "veuillez patienter"
    this._service.routerLink(this.nbrpa).subscribe(e=>{
      console.log(e)
      this.dataExport = e;
      this.urlExport = this.dataExport.url
      this.emptyExport = this.dataExport.empty;
      console.log(this.urlExport)
     window.location.href = 'http://www.testback.kompar-energie.com/'+this.urlExport;
     this.nbrpa++;
     this.testExport = ""
     if(this.emptyExport ==true){
       this.disabledExport = true;
     }

    })
  }
  exporter1(){
    this.testExport = "veuillez patienter"
    this.filtreTab ={
      mail:this.email,
      code_postal:this.codepostal,
      tel:this.tel,
      statu_habitation:this.statut,
      pas:this.nbrpa1
    }
    console.log(this.nbrpa1)
     this._service.getFicheFiltrer1(this.nbrpa).subscribe(e=>{
       console.log(e)
       this.dataExport = e;
       this.urlExport = this.dataExport.url
       this.emptyExport = this.dataExport.empty;
       console.log(this.urlExport)
      window.location.href = 'http://www.testback.kompar-energie.com/'+this.urlExport;
      this.nbrpa1++;
      this.testExport = ""
      if(this.emptyExport ==true){
        this.disabledExport1 = true;
      }
 
     })
   }
  telechargerProvisoir:string;

 /* getFicheProvisoire(){
    this.liste = true;
    this._service.getFicheprovisoir().subscribe(
      data=>{
        this.listFiche= data;
        this.listResult = this.listFiche.array;
        this.listResult = new MatTableDataSource(this.listResult);
        console.log(data)
     this.telechargerProvisoir = this.listFiche.fichier;
        this.listResult.paginator = this.paginator;
        this.listResult.sort = this.sort;
      },error=>{
        alert("erreur")
      }
    )
  }*/
 expPro:boolean;
  exporterProvisoir(){
      if(this.telechargerProvisoir != ''){
        window.location.href = 'http://www.testback.kompar-energie.com'+this.telechargerProvisoir;
        this.expPro = true
      }else{
        this.expPro = false

      }
 
  }
  public changeListener(files: FileList){
    console.log(files);
    if(files && files.length > 0) {
       let file : File = files.item(0); 
         console.log(file.name);
         console.log(file.size);
         console.log(file.type);
         let reader: FileReader = new FileReader();
         reader.readAsText(file);
         reader.onload = (e) => {
            let csv: string = reader.result as string;
            console.log(csv);
         }
      }
  }


  onFileChange(evt: any) {
    const target : DataTransfer =  <DataTransfer>(evt.target);
    
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;

      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      const wsname : string = wb.SheetNames[0];

      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      console.log(ws);

      this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));

      console.log(this.data);
      this.convertToArrayOfObjects(this.data);

      let x = this.data.slice(1);
      console.log(x);

    };

    reader.readAsBinaryString(target.files[0]);

  }
  data: [][];
  convertToArrayOfObjects(data) {
    var keys = data.shift(),
    
        i = 0, k = 0,
        obj = null,
        output = [];
       

    for (i = 0; i < data.length; i++) {
        obj = {};

        for (k = 0; k < keys.length; k++) {
            obj[keys[k]] = data[i][k];
        }

        output.push(obj);
    }
    
    console.log(output)
    this.dataExel = output;
    this.dataExel = JSON.parse(JSON.stringify(this.dataExel).replace(/\s(?=\w+":)/g, ""));
    this.dataExel = JSON.parse(JSON.stringify(this.dataExel).replace(/-/g, ""));

    console.log(this.dataExel)
    return output;
}
dataExel
effacer(){
  this.dataExel = null;
}

supprimer(id){
  
  if(confirm("confirmer la supression ?") == true){
    this._service.deleteBdd(id).subscribe(data=>{
      console.log(data);
      this.listeHome()
    })  }else{
    console.log('no')
  }
}
   codeP = ["01","02","03","04","05","06","07","08","09"]
   display = "none";

fiche = {
  adresse: "",
  civilite: "",
  codepostal: "",
  commentaire: "",
  id:0,
  mail: "",
  nom: "",
  telfix: "",
  telmob: "",
  ville: ""
}
   

   openModal(data) {
     this.fiche = data;
     console.log(this.fiche);
    this.display = "block";
  }
  onCloseHandled() {
    this.display = "none";
  }

  modifier(){
    this._service.updateFiche(this.fiche.id,this.fiche).subscribe(data=>{
      console.log(data);
      this.display = "none";
    })
  }

  suiv(){
    this.getPas ++;
    this._service.getFicheBdd(this.getPas).subscribe(e=>{
      this.listFiche= e;
      this.listResult = this.listFiche;
      this.listResult = new MatTableDataSource(this.listResult);  
      this.listResult.paginator = this.paginator;
      this.listResult.sort = this.sort;

      console.log(this.listFiche)
    })
}
  pre(){
    console.log(this.getPas)
    if(this.getPas < 0){
      this.getPas = 0;
      return
    }
    this.getPas --;
    this._service.getFicheBdd(this.getPas).subscribe(e=>{
      this.listFiche= e;
      this.listResult = this.listFiche;
      this.listResult = new MatTableDataSource(this.listResult);  
      this.listResult.paginator = this.paginator;
      this.listResult.sort = this.sort;

      console.log(this.listFiche)
    })  }
    getPas1:number;
    suiv1(){
      this.getPas1 ++;
      this.filtreTab ={
        mail:this.email,
        code_postal:this.codepostal,
        tel:this.tel,
        statu_habitation:this.statut,
        pas:this.getPas1
      }
      this._service.getFicheFiltrer(this.filtreTab).subscribe(e=>{
        this.listFiche= e;
        this.listResult = this.listFiche;
        this.listResult = new MatTableDataSource(this.listResult);  
        this.listResult.paginator = this.paginator;
        this.listResult.sort = this.sort;
  
        console.log(this.listFiche)
      })
  }
    pre1(){
      console.log(this.getPas1)
      if(this.getPas1 < 0){
        this.getPas1 = 0;
        return
      }
      this.getPas1 --;
      this.filtreTab ={
        mail:this.email,
        code_postal:this.codepostal,
        tel:this.tel,
        statu_habitation:this.statut,
        pas:this.getPas1
      }
      this._service.getFicheFiltrer(this.filtreTab).subscribe(e=>{
        this.listFiche= e;
        this.listResult = this.listFiche;
        this.listResult = new MatTableDataSource(this.listResult);  
        this.listResult.paginator = this.paginator;
        this.listResult.sort = this.sort;
  
        console.log(this.listFiche)
      })  }
    supprimer1(){
      var test = confirm("confirmer la suppression de 1000 fiches")
      console.log(test)
      if( test == true){
        this._service.supprimerBdd().subscribe(data=>{
          console.log(data)
        }, error=>{
          alert("erreur")
        })
      }else{
        return;
      }
    }
}
